import { groupBy } from "../../../../utils";
export function groupRows(data, grouping) {
  var groupFn = grouping.groupFn,
      sortFn = grouping.sortFn;
  var iterable = groupBy(data, groupFn).entries();
  var groups = [];

  while (true) {
    var iteratorResult = iterable.next();
    if (iteratorResult.done) break;
    groups.push(iteratorResult.value);
  }

  if (sortFn) {
    groups = groups.sort(function (a, b) {
      return sortFn(a[0], b[0]);
    });
  }

  return groups;
}